import _ from 'lodash';
import api from '../../utils/service';
import { loadingCycle } from './page';

const GET_EXTERNAL_AUTH_SUCCESS = 'redux/externalAuth/GET_EXTERNAL_AUTH_SUCCESS';
const GET_EXTERNAL_AUTH_FAIL = 'redux/externalAuth/GET_EXTERNAL_AUTH_FAIL';

const initialState = {};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_EXTERNAL_AUTH_SUCCESS:
      return {
        ...state,
        token: _.get(action, 'data.token'),
      };
    case GET_EXTERNAL_AUTH_FAIL:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
}

export function getExternalAuth() {
  return (dispatch) =>
    loadingCycle(api.get('/external-auth'))
      .then(({ data }) => dispatch(getExternalAuthSuccess(data)))
      .catch((error) => dispatch(getExternalAuthFail(error)));
}

export function getExternalAuthSuccess(data) {
  return {
    type: GET_EXTERNAL_AUTH_SUCCESS,
    data,
  };
}

export function getExternalAuthFail(error) {
  return {
    type: GET_EXTERNAL_AUTH_FAIL,
    error: _.get(error, 'response.data.message', _.get(error, 'message')),
  };
}



// WEBPACK FOOTER //
// ./src/redux/modules/externalAuth.js